(function sliderComponentIIFE(window) {
  'use strict';

  var SliderComponent = function sliderComponentConstructor(selector) {
    var element = document.querySelector(selector);

    if (!element || !element.nodeType) {
      throw new Error('The DOM element was not found when creating the tab component');
    }

    return SliderComponent.init(element);
  }

  SliderComponent.prototype.nextSlide = function() {
    SliderComponent.prototype.setSlide.call(this, this.currentIndex + 1);
  }

  SliderComponent.prototype.prevSlide = function() {
    SliderComponent.prototype.setSlide.call(this, this.currentIndex - 1);
  }

  SliderComponent.prototype.setSlide = function(slideIndex) {
    var currentIndex = this.currentIndex;
    var newIndex = slideIndex;
    var self = this;

    // pause on manual call of function
    self.paused = true;
    clearInterval(self.pauseTimeout);
    self.pauseTimeout = setTimeout(function() {
      self.paused = false;
    }, 4500);

    // handle out of bounds of number of slides
    if (newIndex < 0) {
      newIndex = this.slideButtons.length - 1 ;
    } else if (newIndex >= this.slideButtons.length) {
      newIndex = 0;
    }

    // update slide controls
    this.slideButtons[currentIndex].removeAttribute('aria-selected');
    this.slideButtons[newIndex].setAttribute('aria-selected', 'true');
    this.slideItems[currentIndex].removeAttribute('data-slide-active');
    this.slideItems[newIndex].setAttribute('data-slide-active', '');

    // update slide panels
    this.slideSections[currentIndex].setAttribute('aria-hidden', 'true');
    this.slideSections[currentIndex].classList.remove('active-slide');
    this.slideSections[newIndex].setAttribute('aria-hidden', 'false');
    this.slideSections[newIndex].classList.add('active-slide');

    this.currentIndex = newIndex;
    return this;
  }

  SliderComponent.prototype.handleSectionFocus = function(index) {
    this.slideSections[index].focus();

    return this;
  };

  SliderComponent.prototype.addButtons = function() {
    var buttonHtml = '';

    for (var index = 0; index < this.slideSections.length; index++) {
      buttonHtml += SliderComponent.prototype.getButton.call(this, index);
    }

    this.slideList.innerHTML += buttonHtml;
  }

  SliderComponent.prototype.getButton = function(index) {
    var titleIndex = index + 1;
    return '<li class="masthead-slider__control-item"><button class="masthead-slider__control-button" aria-label="Slide '+ titleIndex +'" href="#slide-'+ index +'">'+ titleIndex +'</button></li>';
  }

  // Intialize Tab Component
  SliderComponent.init = function(element) {
    var self = this;
    var interval = 5000;

    this.currentIndex = 0;
    this.paused = false;
    this.pauseTimeout = null;
    this.autoPlay = true;

    this.slideList = element.querySelector('.masthead-slider__control-list');
    this.slideSectionSingle = element.querySelector('.masthead-slide');
    this.slideSections = [].slice.call(element.querySelectorAll('.masthead-slide'));
    this.sliderControls = element.querySelector('.masthead-slider__controls');

    if(this.slideSections.length > 1) {
      SliderComponent.prototype.addButtons.call(self);

      this.slideButtons = [].slice.call(this.slideList.querySelectorAll('.masthead-slider__control-button'));
      this.slideItems = [].slice.call(this.slideList.querySelectorAll('.masthead-slider__control-item'));
      this.slideList.setAttribute('role', 'tablist');
      this.prevArrow = element.querySelector('.masthead-slider__button--prev');
      this.nextArrow = element.querySelector('.masthead-slider__button--next');
      this.playButton = element.querySelector('.masthead-slider__play-pause-button');

      this.slideButtons.forEach(function(item, index) {
        item.setAttribute('role', 'tab');
        item.setAttribute('id', 'slide' + index);

        if (index < 0) {
          item.setAttribute('aria-selected', 'true');
        }

      });

      this.slideItems.forEach(function(item, index) {
        item.setAttribute('role', 'presentation');

        if (index === 0) {
          item.setAttribute('data-slide-active', '');
        }
      });

      this.slideList.addEventListener('click', function(event) {
        event.preventDefault();
        SliderComponent.prototype.setSlide.call(self, self.slideButtons.indexOf(event.target));
      });

      this.slideList.addEventListener('keydown', function(event) {
        var index = self.slides.indexOf(event.target);

        // Left and right arrows
        if (event.which === 37) {
          event.preventDefault();
          self.prevSlide();

        } else if (event.which === 39) {
          event.preventDefault();
          self.nextSlide();
        }

        // Down arrow
        if (event.which === 40) {
          event.preventDefault();
          SliderComponent.prototype.handleSectionFocus.call(self, index);
        }

      });

      this.slideSections.forEach(function(item, index) {
        item.setAttribute('role', 'tabpanel');
        item.setAttribute('aria-labelledby', 'slide' + index);
        item.setAttribute('id', 'slide-' + index);

        if (index > 0) {
          item.setAttribute('aria-hidden', 'true');
        }

        if (index === 0) {
          item.classList.add('active-slide');
          item.setAttribute('aria-hidden', 'false');
        }
      });

      this.timer = setInterval(function() {
        if (self.autoPlay && !self.paused) {
          SliderComponent.prototype.nextSlide.call(self);
        }
      }, interval);

      this.prevArrow.addEventListener('click', function(event) {
        event.preventDefault();
        SliderComponent.prototype.prevSlide.call(self);
      });

      this.nextArrow.addEventListener('click', function(event) {
        event.preventDefault();
        SliderComponent.prototype.nextSlide.call(self);
      });

      this.playButton.addEventListener('click', function() {
        self.autoPlay = !self.autoPlay;

        if (self.autoPlay) {
          self.playButton.classList.add('is-playing');
          self.playButton.setAttribute('aria-label', 'Play Slideshow');

        } else {
          self.playButton.classList.remove('is-playing');
          self.playButton.setAttribute('aria-label', 'Pause Slideshow');
        }

      });

    } else {
      this.sliderControls.classList.add('hidden');
      this.slideSectionSingle.classList.add('active-slide');
    }

    return this;
  }

  window.slides = SliderComponent
})(window);
